export default "__VITE_ASSET__BCGZ3K7k__"